// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"BT","tooltipWrapper":"CT","tooltip":"DT","content":"ET"};